/* eslint-disable no-undef */
$(document).ready(function() {
  $(window).scroll(function() {
    if ($(this).scrollTop() >= 60) {
      $("#scrollTop").addClass("visible");
    } else {
      $("#scrollTop").removeClass("visible");
    }
  });
});

$(document).on("click", "#scrollTop", function() {
  $("body,html").animate({ scrollTop: 0 }, 500);
});

$(document).on("click", "*[data-toggle]", function(event) {
  let type = event.target.getAttribute("data-toggle");
  if (type == "modal") {
    let targetId = event.target.getAttribute("data-target");
    $(targetId).toggleClass("active");
  }
});

$(document).on("click", ".u-modal__background", function(event) {
  let modalId = event.target.parentNode.getAttribute("id");
  $("#" + modalId).toggleClass("active");
});

$(document).on("click", "*.u-modal__close", function(event) {
  let modalId = event.currentTarget.parentNode.parentNode.parentNode.getAttribute(
    "id"
  );
  $("#" + modalId).toggleClass("active");
});
